/**
 * Fixed response periods for clauses that are not negotiated.
 *
 * These used to read `contingency.homeinspectionNegotiationDays`, so agreeing
 * a shorter inspection period silently shortened every notice deadline too —
 * e.g. a 3-day inspection window left Seller 3 days before settlement to order
 * the municipal certificate. The values below follow the standard form these
 * clauses are drawn from (5-day notice and response periods; certificate
 * ordered within 30 days of execution and no later than 15 days before
 * settlement). Counsel should confirm them before public release.
 *
 * Used by both the on-screen contract and the downloadable PDF so the two
 * always state the same numbers.
 */
export const CONTRACT_DEADLINES = {
  /** Notices & assessments: each party's notice / response period. */
  noticeResponseDays: 5,
  /** Municipal certification: order within this many days of execution… */
  municipalCertOrderDays: 30,
  /** …but no later than this many days before Settlement Date. */
  municipalCertDaysBeforeSettlement: 15,
  /** Maintenance & risk of loss: Buyer's response period (clauses 2c and 2d). */
  maintenanceResponseDays: 5,
} as const;
